import { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Calendar, ArrowLeft } from "lucide-react";

export default function JournalPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/posts/${slug}`)
      .then((r) => setPost(r.data))
      .catch(() => setNotFound(true));
  }, [slug]);

  const paragraphs = useMemo(
    () => (post?.body || "").split("\n").filter(Boolean),
    [post]
  );

  if (notFound) {
    return (
      <div className="max-w-3xl mx-auto px-6 py-24 text-center">
        <h1 className="font-serif-display text-4xl mb-4">Entry not found</h1>
        <Link to="/journal" className="text-[var(--forest)] underline">Back to the journal</Link>
      </div>
    );
  }
  if (!post) return <div className="p-16 text-center text-[var(--ink-soft)]">Loading…</div>;

  return (
    <article data-testid="journal-post-page" className="max-w-3xl mx-auto px-6 md:px-10 py-16 md:py-20">
      <Link to="/journal" className="inline-flex items-center gap-1.5 text-sm text-[var(--ink-soft)] hover:text-[var(--forest)] mb-10">
        <ArrowLeft className="w-3.5 h-3.5" /> All entries
      </Link>

      <div className="inline-flex items-center gap-1.5 text-xs font-mono-acc text-[var(--ink-soft)] mb-4">
        <Calendar className="w-3 h-3" />{(post.created_at || "").slice(0, 10)}
      </div>
      <h1 className="font-serif-display text-5xl md:text-6xl leading-[1.05] mb-8">{post.title}</h1>

      {post.image_url && (
        <img src={post.image_url} alt={post.title}
          className="w-full max-h-[520px] object-cover rounded-sm mb-10" />
      )}

      <div className="prose-content text-lg leading-relaxed text-[var(--ink-soft)] space-y-5">
        {paragraphs.map((para, i) => (
          <p key={`${i}-${para.slice(0, 24)}`}>{para}</p>
        ))}
      </div>
    </article>
  );
}
